<template>
    <c-dialog ref="dialog" enable-flex width="85vw" mode="slide" mask-close>
        <template #head>
            <div class="m-detail-tag flex-center-cross">
                <c-state tag async dict="CHECK_PAYMENT_CHANNEL" :value="check_payment_channel"></c-state>
            </div>
        </template>

        <c-form ref="purchaseForm" column="3" vertical unit-width="100%">
            <c-title>核销商品明细</c-title>
            <c-table ref="productTable" :data="productList" border :paging="false">
                <c-table-column label="三方流水号" width="120" required>
                    <template #default="{data}">
                        <span>{{data.third_number||'-'}}</span>
                    </template>
                </c-table-column>
                <c-table-column label="平台订单号" width="120" required>
                    <template #default="{data}">
                        <span>{{data.order_no||'-'}}</span>
                    </template>
                </c-table-column>
                <c-table-column label="背贴码" width="150" required>
                    <template #default="{data}">
                        <span>{{data.produce_unique_code||'-'}}</span>
                        <c-input type="hidden" name="inspection_state" v-model="data.inspection_state"></c-input>
                    </template>
                </c-table-column>
                <c-table-column label="核销状态" width="100" required>
                    <template #default="{data}">
                        <c-state tag async dict="CHECK_ORDER_STATUS" :value="data.check_state"></c-state>
                    </template>
                </c-table-column>
                <c-table-column label="已结算金额" width="120" required>
                    <template #default="{data}">
                        <span>￥{{data.check_settled_money||'0.00'}}</span>
                    </template>
                </c-table-column>
                <c-table-column label="渠道实收金额" width="120" required>
                    <template #default="{data}">
                        <span>￥{{data.check_receipt_money||'0.00'}}</span>
                    </template>
                </c-table-column>
                <c-table-column label="最终结算金额" width="120" required>
                    <template #default="{data}">
                        <c-input name="platform_receipt_money" v-model="data.platform_receipt_money" type="number" decimal="2" :range="[-999999,999999]"
                                 placeholder="最终结算金额" append-text="元" :clear="false"></c-input>
                    </template>
                </c-table-column>
                <c-table-column label="平台订单金额" width="120" required>
                    <template #default="{data}">
                        <span>￥{{data.platform_sale_price||'0.00'}}</span>
                    </template>
                </c-table-column>
                <c-table-column label="平台售后金额" width="120" required>
                    <template #default="{data}">
                        <span>￥{{data.platform_return_money||'0.00'}}</span>
                    </template>
                </c-table-column>
                <c-table-column label="平台补差金额" width="120" required>
                    <template #default="{data}">
                        <span>￥{{data.platform_supplement_money||'0.00'}}</span>
                    </template>
                </c-table-column>
                <c-table-column label="渠道订单金额" width="120" required>
                    <template #default="{data}">
                        <span>￥{{data.check_product_money||'0.00'}}</span>
                    </template>
                </c-table-column>
                <c-table-column label="渠道售后金额" width="120" required>
                    <template #default="{data}">
                        <span>￥{{data.check_return_money||'0.00'}}</span>
                    </template>
                </c-table-column>
                <c-table-column label="渠道补差金额" width="120" required>
                    <template #default="{data}">
                        <span>￥{{data.check_supplement_money||'0.00'}}</span>
                    </template>
                </c-table-column>
                <c-table-column label="收款日期" width="180" required>
                    <template #default="{data}">
                        <span>{{data.receipt_date||''}}</span>
                    </template>
                </c-table-column>

                <c-table-column type="button" label="操作" width="120">
                    <template #default="row">
                        <c-table-button icon="tf-trash" color="red" @click="removeRow(row);">删除</c-table-button>
                    </template>
                </c-table-column>
            </c-table>
        </c-form>
        <template #button>
            <c-button v-if="auth('b_xiaohei_order_check_create')" size="dialog" :disabled="isSubmitting" @click="submitHandle(0)">{{isEdit ? '暂存草稿' : '保存草稿'}}</c-button>
            <c-button v-if="auth('b_xiaohei_order_check_audit')" color="main" size="dialog" :disabled="isSubmitting" @click="submitHandle(2)">{{isEdit ? '提交审核' : '保存并提交审核'}}</c-button>
        </template>
    </c-dialog>
</template>

<script>

export default {
    name: 'orderCheckEdit',
    components: {
    },

    data() {
        return {
            check_payment_channel:0,//付款渠道
            check_order_id:0,//编辑的核销单ID（0=新增导入）
            isEdit:false,//是否编辑模式（待核销/审核驳回状态可编辑）
            productList:[],
            isSubmitting:false//是否正在提交（防止重复提交）
        }
    },

    methods: {
        //打开弹窗
        open(data) {
            this.check_payment_channel = data.check_payment_channel;
            this.check_order_id = data.id||0;
            this.isEdit = !!this.check_order_id;//携带核销单ID则为编辑模式
            this.productList = data.import_data_list||[];
            this.isSubmitting = false;//重置提交状态（兜底，防止上次异常中断导致标志卡死）
            this.$refs.dialog.open({
                title: this.isEdit ? '编辑核销单' : '批量导入核销'
            });
            if (this.isEdit) {
                this.loadProductList();
            }
        },
        /******编辑模式：加载核销单商品明细并回显*********/
        loadProductList() {
            this.request({
                url: '/sale/check/product/list',
                data: {
                    check_order_id: this.check_order_id,
                    pageIndex: 1,
                    pageSize: 999
                },
                loading: true,
                success: data => {
                    this.productList = (data||[]).map(item => {
                        //编辑回显：最终结算金额初始化为渠道实收金额（提交校验要求“结算金额=渠道实收金额”）
                        item.platform_receipt_money = item.check_receipt_money;
                        return item;
                    });
                }
            });
        },
        /******删除行数据*********/
        removeRow(row) {
            this.$confirm({
                type: 'warn',
                message: (row.data.produce_unique_code ? '是否确认删除背贴码【' + row.data.produce_unique_code + '】' : '是否确认删除选中数据行'),
                buttonName: '确认删除',
                cancelButton: true,
                resolve: () => {
                    row.remove();
                }
            });
        },
        /*******提交编辑数据********************/
        submitHandle(status) {
            //防止重复提交：请求进行中直接忽略点击
            if (this.isSubmitting) return;
            //产品工单列表
            var product_list = this.$refs.productTable.getData();

            if (!product_list || product_list.length == 0){
                this.$message({
                    message: '至少需要核销一件商品',
                    type: 'warn'
                });
                return;
            }
            //过滤
            const diffList = product_list.filter(item => item.platform_receipt_money != item.check_receipt_money);
            if (diffList && diffList.length > 0){
                this.$message({
                    message: '商品的“结算金额”，必须等于“渠道实收金额”',
                    type: 'warn'
                });
                return;
            }
            this.isSubmitting = true;
            this.request({
                //编辑模式：更新核销单（暂存待核销/提交审核）；新增模式：新增核销单
                url: this.isEdit ? '/sale/check/update' : '/sale/check/add',
                //请求期间显示全屏遮罩，物理阻断重复点击
                loading: true,
                data: this.isEdit ? {
                    id:this.check_order_id,
                    status:status,
                    product_list:product_list
                } : {
                    status:status,
                    check_payment_channel:this.check_payment_channel,
                    product_list:product_list
                },
                success:data => {
                    this.$message({
                        message: status==0?'数据已保存为“待核销”状态':'数据已保存为“待审核”状态，等待审核',
                        type: 'success'
                    });
                    //执行回调函数
                    this.$emit('resolve');
                    this.$refs.dialog.close();
                },
                //成功/业务失败后均会执行，重置提交状态
                complete:() => {
                    this.isSubmitting = false;
                },
                //网络异常/超时时complete不会执行，此处兜底重置
                error:() => {
                    this.isSubmitting = false;
                }
            })
        }
    }
}
</script>

<style lang="stylus" scoped>
</style>